import React from "react";
import DoneIcon from "material-ui/svg-icons/action/done";
import Globalize from "globalize";
import { themeOptions } from "styles/theme";

const styles = {
    root: {
        display: "flex",
        lineHeight: "38px",
        paddingLeft: "24px",
        borderBottom: `1px solid ${themeOptions.palette.borderColor}`,
    },
    icon: {
        marginRight: "10px",
        height: "36px",
        width: "36px",
        position: "relative",
        top: "10px",
    },
    headline: {
        flexGrow: "1",
        fontSize: "24px",
    },
    iconButton: {
        position: "absolute",
        top: "0px",
        right: "0px",
    },
};

export const ModalTitle = ({ type }) => {
    return (
        <div style={styles.root}>
            {type === "success" && <DoneIcon color={themeOptions.palette.primary1Color} style={styles.icon} />}
            <h2 style={styles.headline}>
                {type === "success"
                    ? Globalize.formatMessage("Your Payment Has Been Processed")
                    : Globalize.formatMessage("Payment Processing Error")}
            </h2>
        </div>
    );
};
